import { useState, useEffect } from 'react'

const API = `${import.meta.env.VITE_API_URL || 'http://localhost:3001'}`

function AdminMotoristas() {
    const [motoristas, setMotoristas] = useState([])
    const [loading, setLoading] = useState(true)
    const [erro, setErro] = useState('')
    const [busca, setBusca] = useState('')
    const [filtroStatus, setFiltroStatus] = useState('todos')
    const [pagina, setPagina] = useState(1)
    const [totalPaginas, setTotalPaginas] = useState(1)
    
    // Modal de Detalhes
    const [selectedUserId, setSelectedUserId] = useState(null)
    const [userDetails, setUserDetails] = useState(null)
    const [loadingDetails, setLoadingDetails] = useState(false)

    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }

    useEffect(() => {
        carregarMotoristas()
    }, [pagina, filtroStatus])

    const carregarMotoristas = async () => {
        setLoading(true)
        setErro('')
        try {
            const params = new URLSearchParams({ page: pagina, limit: 15 })
            if (filtroStatus && filtroStatus !== 'todos') params.append('status_plano', filtroStatus)
            if (busca) params.append('search', busca)

            const res = await fetch(`${API}/api/admin/motoristas?${params}`, { headers })
            if (!res.ok) throw new Error('Erro ao carregar motoristas')

            const data = await res.json()
            setMotoristas(data.motoristas || [])
            setTotalPaginas(data.totalPaginas || 1)
        } catch (error) {
            console.error('Erro:', error)
            setErro('Não foi possível carregar os motoristas.')
        } finally {
            setLoading(false)
        }
    }

    const handleBusca = (e) => {
        e.preventDefault()
        setPagina(1)
        carregarMotoristas()
    }

    const handleViewDetails = async (id) => {
        setLoadingDetails(true)
        setSelectedUserId(id)
        try {
            const res = await fetch(`${API}/api/admin/usuarios/${id}`, { headers })
            const data = await res.json()
            if (!res.ok) throw new Error(data.message || 'Erro ao carregar')
            setUserDetails(data)
        } catch (err) {
            alert('Erro ao carregar detalhes do motorista')
        } finally {
            setLoadingDetails(false)
        }
    }

    const closeDetails = () => {
        setSelectedUserId(null)
        setUserDetails(null)
    }

    const handleRevogarMotorista = async (id, nome) => {
        if (!window.confirm(`Tem certeza que deseja REVOGAR os privilégios de motorista de ${nome}? Os dados do veículo serão apagados.`)) return;

        try {
            const res = await fetch(`${API}/api/admin/usuarios/${id}/remover-motorista`, {
                method: 'PUT',
                headers
            })
            const data = await res.json()
            if (!res.ok) throw new Error(data.message || 'Erro ao revogar')
            
            alert('Privilégios de motorista revogados com sucesso!')
            carregarMotoristas()
        } catch (err) {
            alert('Erro: ' + err.message)
        }
    }

    const formatDate = (date) => date ? new Date(date).toLocaleDateString('pt-BR') : '—'

    const filtros = [
        { key: 'todos', label: 'Todos' },
        { key: 'ativos', label: 'Plano Ativo' },
        { key: 'expirados', label: 'Plano Expirado' },
        { key: 'pendentes', label: 'Plano Pendente/Não Assinado' },
    ]

    return (
        <div>
            <div className="admin-section-header" style={{ marginBottom: '1.5rem' }}>
                <h3>🚚 Gestão de Motoristas</h3>
            </div>

            {erro && <div className="admin-error">{erro}</div>}

            {/* Toolbar */}
            <div className="admin-toolbar">
                <form onSubmit={handleBusca} style={{ flex: 1, display: 'flex', minWidth: 220 }}>
                    <input
                        type="text"
                        className="admin-search-input"
                        placeholder="Buscar por nome, email ou WhatsApp..."
                        value={busca}
                        onChange={(e) => setBusca(e.target.value)}
                        style={{ flex: 1 }}
                    />
                </form>

                <div className="admin-filter-tabs">
                    {filtros.map(f => (
                        <button
                            key={f.key}
                            className={`admin-filter-tab ${filtroStatus === f.key ? 'active' : ''}`}
                            onClick={() => { setFiltroStatus(f.key); setPagina(1); }}
                        >
                            {f.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Table */}
            {loading ? (
                <div className="admin-loading">
                    <div className="spinner"></div>
                    <span>Carregando motoristas...</span>
                </div>
            ) : (
                <div className="admin-section">
                    <div className="admin-table-wrapper">
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>Motorista</th>
                                    <th className="hide-mobile">Contato</th>
                                    <th>Veículo</th>
                                    <th className="hide-mobile">Capacidade</th>
                                    <th>Status do Plano</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {motoristas.length > 0 ? (
                                    motoristas.map(user => {
                                        const isAtivo = user.expiracao_motorista && new Date(user.expiracao_motorista) > new Date();
                                        const isExpirado = user.expiracao_motorista && new Date(user.expiracao_motorista) <= new Date();
                                        const diasRestantes = user.expiracao_motorista ? Math.max(0, Math.ceil((new Date(user.expiracao_motorista) - new Date()) / (1000 * 60 * 60 * 24))) : 0;
                                        
                                        return (
                                        <tr key={user.id}>
                                            <td data-label="Motorista">
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    {user.foto_perfil ? (
                                                        <img src={user.foto_perfil.startsWith('http') ? user.foto_perfil : `${API}/uploads/profiles/${user.foto_perfil}`} alt="" className="user-avatar" style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover' }} />
                                                    ) : (
                                                        <div style={{
                                                            width: 40, height: 40, borderRadius: '50%',
                                                            background: 'var(--color-bg-card)',
                                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                            fontSize: '1.2rem', color: 'var(--color-text-muted)'
                                                        }}>
                                                            👤
                                                        </div>
                                                    )}
                                                    <div>
                                                        <div style={{ color: '#f8fafc', fontWeight: 500 }}>{user.nome}</div>
                                                        <div style={{ fontSize: '0.8rem', color: '#94a3b8' }}>{user.email}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td data-label="Contato" className="hide-mobile">
                                                <div style={{ color: '#f8fafc' }}>{user.whatsapp || user.telefone || '-'}</div>
                                            </td>
                                            <td data-label="Veículo">
                                                {user.tipo_veiculo ? (
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <strong style={{ color: '#f8fafc' }}>{user.tipo_veiculo}</strong>
                                                        <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>{user.modelo_veiculo || ''} {user.placa_veiculo ? `- Placa: ${user.placa_veiculo}` : ''}</span>
                                                    </div>
                                                ) : <span style={{ color: '#64748b' }}>Não informado</span>}
                                            </td>
                                            <td data-label="Capacidade" className="hide-mobile">
                                                {user.capacidade_peso ? `${user.capacidade_peso} kg` : '-'}
                                                <br/>
                                                <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>{user.capacidade_gado ? `${user.capacidade_gado} cabeças` : ''}</span>
                                            </td>
                                            <td data-label="Status do Plano">
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                    {isAtivo ? (
                                                        <span className="admin-badge admin-badge-ativo" style={{ width: 'fit-content', backgroundColor: '#10b981', color: '#0f172a' }}>
                                                            🚚 ATIVO ({diasRestantes} dias)
                                                        </span>
                                                    ) : isExpirado ? (
                                                        <span className="admin-badge admin-badge-inativo" style={{ width: 'fit-content', backgroundColor: '#ef4444', color: 'white' }}>
                                                            ❌ EXPIRADO
                                                        </span>
                                                    ) : (
                                                        <span className="admin-badge" style={{ width: 'fit-content', backgroundColor: '#64748b', color: 'white' }}>
                                                            ⏳ PENDENTE
                                                        </span>
                                                    )}
                                                </div>
                                            </td>
                                            <td data-label="Ações">
                                                <div className="admin-actions">
                                                    <button className="admin-btn-icon" onClick={() => handleViewDetails(user.id)} title="Ver Ficha Completa">
                                                        👁️
                                                    </button>
                                                    <button className="admin-btn-icon" style={{ color: '#ef4444' }} onClick={() => handleRevogarMotorista(user.id, user.nome)} title="Revogar Privilégios de Motorista (e limpar veículo)">
                                                        🚫
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    )})
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: 'center', padding: '2rem', color: '#64748b' }}>
                                            Nenhum motorista encontrado.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="admin-pagination">
                        <button disabled={pagina <= 1} onClick={() => setPagina(p => p - 1)}>
                            ← Anterior
                        </button>
                        <span className="page-info">Página {pagina} de {totalPaginas}</span>
                        <button disabled={pagina >= totalPaginas} onClick={() => setPagina(p => p + 1)}>
                            Próxima →
                        </button>
                    </div>
                </div>
            )}

            {/* Modal Reutilizado */}
            {selectedUserId && (
                <div className="admin-modal-overlay" onClick={closeDetails} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="admin-modal-content" onClick={e => e.stopPropagation()} style={{ backgroundColor: '#0f172a', padding: '20px', borderRadius: '12px', maxWidth: '700px', width: '90%', maxHeight: '90vh', overflowY: 'auto', border: '1px solid #334155' }}>
                        <div className="admin-modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '1px solid #334155', paddingBottom: '15px' }}>
                            <h3 style={{ margin: 0, color: 'white', fontSize: '1.25rem' }}>Detalhes do Motorista</h3>
                            <button onClick={closeDetails} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: '1.5rem', cursor: 'pointer' }}>&times;</button>
                        </div>
                        
                        {loadingDetails ? (
                            <div style={{ textAlign: 'center', padding: '40px' }}><div className="loading-spinner"></div> Carregando...</div>
                        ) : userDetails ? (
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', color: '#cbd5e1' }}>
                                <div style={{ gridColumn: '1 / -1', display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '10px' }}>
                                    {userDetails.foto_perfil ? (
                                        <img src={userDetails.foto_perfil.startsWith('http') ? userDetails.foto_perfil : `${API}/uploads/profiles/${userDetails.foto_perfil}`} alt={userDetails.nome} style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover' }} />
                                    ) : (
                                        <div style={{ width: '80px', height: '80px', borderRadius: '50%', backgroundColor: '#1e293b', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2rem' }}>
                                            👤
                                        </div>
                                    )}
                                    <div>
                                        <h2 style={{ margin: '0 0 5px 0', color: 'white' }}>{userDetails.nome}</h2>
                                        <div style={{ color: '#94a3b8' }}>{userDetails.email}</div>
                                        <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                                            {userDetails.ativo ? <span className="admin-badge" style={{ backgroundColor: '#10b981', color: '#0f172a' }}>ATIVO</span> : <span className="admin-badge" style={{ backgroundColor: '#ef4444', color: 'white' }}>INATIVO</span>}
                                        </div>
                                    </div>
                                </div>

                                <div className="detail-group" style={{ backgroundColor: '#1e293b', padding: '15px', borderRadius: '8px' }}>
                                    <div style={{ color: '#94a3b8', fontSize: '0.8rem', marginBottom: '5px' }}>Telefone / Celular</div>
                                    <div>{userDetails.telefone || '-'}</div>
                                </div>

                                <div className="detail-group" style={{ backgroundColor: '#1e293b', padding: '15px', borderRadius: '8px' }}>
                                    <div style={{ color: '#94a3b8', fontSize: '0.8rem', marginBottom: '5px' }}>WhatsApp</div>
                                    <div>{userDetails.whatsapp || '-'}</div>
                                </div>

                                <div className="detail-group" style={{ backgroundColor: '#1e293b', padding: '15px', borderRadius: '8px' }}>
                                    <div style={{ color: '#94a3b8', fontSize: '0.8rem', marginBottom: '5px' }}>CPF/CNPJ</div>
                                    <div>{userDetails.cpf_cnpj || '-'}</div>
                                </div>

                                <div className="detail-group" style={{ backgroundColor: '#1e293b', padding: '15px', borderRadius: '8px' }}>
                                    <div style={{ color: '#94a3b8', fontSize: '0.8rem', marginBottom: '5px' }}>Data de Cadastro</div>
                                    <div>{new Date(userDetails.criado_em).toLocaleString('pt-BR')}</div>
                                </div>

                                <div className="detail-group" style={{ backgroundColor: '#1e293b', padding: '15px', borderRadius: '8px', gridColumn: '1 / -1' }}>
                                    <div style={{ color: '#94a3b8', fontSize: '0.8rem', marginBottom: '5px' }}>Endereço Pessoal</div>
                                    <div>{userDetails.endereco ? `${userDetails.endereco}, ` : ''}{userDetails.cidade || '-'} - {userDetails.estado || '-'}</div>
                                </div>

                                <div className="detail-group" style={{ backgroundColor: '#1e293b', padding: '15px', borderRadius: '8px', gridColumn: '1 / -1' }}>
                                    <div style={{ color: '#94a3b8', fontSize: '0.8rem', marginBottom: '5px' }}>Planos e Benefícios</div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                        <div><strong>Créditos de Anúncio:</strong> {userDetails.creditos_anuncio || 0}</div>
                                        <div>
                                            <strong>Plano PRO:</strong> {userDetails.assinatura_ilimitada && userDetails.expiracao_assinatura && new Date(userDetails.expiracao_assinatura) > new Date() ? (
                                                <span>
                                                    Sim (Expira em: {new Date(userDetails.expiracao_assinatura).toLocaleDateString()} 
                                                    <span style={{ color: '#10b981', marginLeft: '5px' }}>
                                                        — Faltam {Math.max(0, Math.ceil((new Date(userDetails.expiracao_assinatura) - new Date()) / (1000 * 60 * 60 * 24)))} dias
                                                    </span>)
                                                </span>
                                            ) : userDetails.assinatura_ilimitada && userDetails.expiracao_assinatura ? (
                                                <span style={{ color: '#ef4444' }}>
                                                    Não (Expirou em {new Date(userDetails.expiracao_assinatura).toLocaleDateString()})
                                                </span>
                                            ) : 'Não'}
                                        </div>
                                        <div>
                                            <strong>Plano Motorista:</strong> {userDetails.motorista_verificado && userDetails.expiracao_motorista && new Date(userDetails.expiracao_motorista) > new Date() ? (
                                                <span>
                                                    Sim (Expira em: {new Date(userDetails.expiracao_motorista).toLocaleDateString()}
                                                    <span style={{ color: '#10b981', marginLeft: '5px' }}>
                                                        — Faltam {Math.max(0, Math.ceil((new Date(userDetails.expiracao_motorista) - new Date()) / (1000 * 60 * 60 * 24)))} dias
                                                    </span>)
                                                </span>
                                            ) : userDetails.motorista_verificado && userDetails.expiracao_motorista ? (
                                                <span style={{ color: '#ef4444' }}>
                                                    Não (Expirou em {new Date(userDetails.expiracao_motorista).toLocaleDateString()})
                                                </span>
                                            ) : 'Não'}
                                        </div>
                                    </div>
                                </div>

                                {(userDetails.tipo_ativo === 'motorista' || userDetails.tipo_veiculo) && (
                                    <div className="detail-group" style={{ backgroundColor: '#1e293b', padding: '15px', borderRadius: '8px', gridColumn: '1 / -1' }}>
                                        <div style={{ color: '#94a3b8', fontSize: '0.8rem', marginBottom: '10px' }}>Dados do Veículo</div>
                                        <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
                                            {userDetails.foto_veiculo && (
                                                <img 
                                                    src={userDetails.foto_veiculo.startsWith('http') ? userDetails.foto_veiculo : (userDetails.foto_veiculo.replace(/^\//, '').startsWith('uploads/') ? `${API}/${userDetails.foto_veiculo.replace(/^\//, '')}` : `${API}/uploads/${userDetails.foto_veiculo.replace(/^\//, '')}`)} 
                                                    alt="Veículo" 
                                                    style={{ width: '120px', height: '120px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #334155' }} 
                                                />
                                            )}
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', flex: 1 }}>
                                                <div><strong>Tipo:</strong> {userDetails.tipo_veiculo || '-'}</div>
                                                <div><strong>Modelo:</strong> {userDetails.modelo_veiculo || '-'}</div>
                                                <div><strong>Placa:</strong> {userDetails.placa_veiculo || '-'}</div>
                                                <div><strong>Capacidade (Peso):</strong> {userDetails.capacidade_peso ? `${userDetails.capacidade_peso} kg` : '-'}</div>
                                                <div><strong>Capacidade (Gado):</strong> {userDetails.capacidade_gado ? `${userDetails.capacidade_gado} cabeças` : '-'}</div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : null}
                    </div>
                </div>
            )}
        </div>
    )
}

export default AdminMotoristas
